// extracted by mini-css-extract-plugin
export var border = "_bi-b";
export var circle = "_bi-3";
export var circleInner = "_bi-5";
export var disabled = "_bi-1";
export var focused = "_bi-a";
export var md = "_bi-8";
export var radioButton = "_bi-0";
export var radioInput = "_bi-2";
export var selected = "_bi-9";
export var sm = "_bi-7";
export var text = "_bi-4";
export var xs = "_bi-6";